export const TOKEN_TTL_SECONDS = 4 * 60
export const SESSION_TOKEN_COOKIE_NAME =
  process.env.NODE_ENV === 'production' && !process.env.CYPRESS
    ? '__Secure-next-auth.session-token'
    : 'next-auth.session-token'

export enum UserRole {
  user = 'user',
  admin = 'admin-user',
}

export enum NextAuthErrors {
  CredentialsSignin = 'CredentialsSignin',
  AccountDoesNotExist = 'AccountDoesNotExist',
  ActivateAccount = 'ActivateAccount',
  Default = 'Default',
}
